"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferManualDTO = exports.RefuseFriendshipDTO = exports.CancelFriendshipInviteDTO = exports.CreateFriendshipDTO = exports.BreakFriendshipDTO = exports.AcceptPendingFriendshipDTO = exports.UserPendingFriendshipsDTO = exports.FriendshipStatus = void 0;
var FriendshipStatus;
(function (FriendshipStatus) {
    FriendshipStatus["None"] = "None";
    FriendshipStatus["Friend"] = "Friend";
    FriendshipStatus["Invited"] = "Invited";
    FriendshipStatus["InvitedYou"] = "InvitedYou";
})(FriendshipStatus = exports.FriendshipStatus || (exports.FriendshipStatus = {}));
class UserPendingFriendshipsDTO {
}
exports.UserPendingFriendshipsDTO = UserPendingFriendshipsDTO;
class AcceptPendingFriendshipDTO {
}
exports.AcceptPendingFriendshipDTO = AcceptPendingFriendshipDTO;
class BreakFriendshipDTO {
}
exports.BreakFriendshipDTO = BreakFriendshipDTO;
class CreateFriendshipDTO {
}
exports.CreateFriendshipDTO = CreateFriendshipDTO;
class CancelFriendshipInviteDTO {
}
exports.CancelFriendshipInviteDTO = CancelFriendshipInviteDTO;
class RefuseFriendshipDTO {
}
exports.RefuseFriendshipDTO = RefuseFriendshipDTO;
class OfferManualDTO {
}
exports.OfferManualDTO = OfferManualDTO;
//# sourceMappingURL=Friendship.js.map